import * as React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import {Breadcrumb} from '~/components/Breadcrumps';
import {useAbility} from '~/lib/ability';
import {BiddersAbility} from '~/modules/Bidders/ability';
import {biddersLinks} from '~/modules/Bidders/links';
import {BiddersView} from '~/modules/Bidders/views/BiddersView';
import {BidderView} from '~/modules/Bidders/views/BidderView';
import {BidderGroupsView} from '~/modules/Bidders/views/BidderGroupsView';
import {BidderGroupView} from '~/modules/Bidders/views/BidderGroupView';
import {PreTargetingConfigView} from '~/modules/Bidders/views/PreTargetingConfigView';
import {PreTargetingWizardView} from '~/modules/Bidders/views/PreTargetingWizardRulesView';

export const BiddersRoute = () => {
    const ability = useAbility(BiddersAbility);
    return <Breadcrumb breadcrumb={{
        to: biddersLinks.bidders(),
        title: 'Bidders'
    }}
    ><Routes>
            <Route index element={<BiddersView/>}/>
            {ability.canCreate() && <Route path="create" element={<BidderView create />} />}
            <Route path="groups" element={<BidderGroupsView/>}/>
            <Route path="groups/create" element={<BidderGroupView create/>}/>
            <Route path="groups/:groupId" element={<BidderGroupView/>}/>
            <Route path=":bidderId" element={<BidderView/>}/>
            {ability.canViewPreTargeting() && <>
                <Route path=":bidderId/pre-targeting/:preTargetingConfigId"
                    element={<PreTargetingConfigView/>}/>
                <Route path=":bidderId/pre-targeting/:preTargetingConfigId/wizard"
                    element={<PreTargetingWizardView/>}/>
            </>}
            <Route path="*" element={<Navigate to={biddersLinks.bidders()} replace />}/>
        </Routes>
    </Breadcrumb>;
};